<template>
  <div>
    <div v-if="invoices && invoices.length" class="alert alert-light alert-card-attached d-flex justify-content-between">
      <span v-if="invoices.length === maxResults">
        Laetud {{maxResults}} värskemat kirjet, täpsusta otsingut
      </span>
      <span v-else>
        Laetud {{invoices.length}} kirjet
      </span>

      <permission name="InvoiceExportBooks" style="float: right">
        <a target="_blank" :href="`/api/invoices/export/sb?${exportParams}`" title="Ekspordi Standard Booksi"><i class="mdi mdi-download mr-1"></i>Ekspordi Standard Booksi</a>
      </permission>
      <a target="_blank" :href="`/api/invoices/export/xlsx?maxResults=3000&${exportParams}`" title="Ekspordi Excelisse"><i class="mdi mdi-download mr-1"></i>Ekspordi Excelisse</a>
    </div>

    <table v-if="invoices && invoices.length" class="table table-sm table-centered table-hover table-sticky mt-4 mb-0">
      <thead>
        <tr>
          <th></th>
          <th>Arve nr.</th>
          <th>Klient</th>
          <th>Staatus</th>
          <th>Koostaja</th>
          <th width="150">Arve kuupäev</th>
          <th width="160">Tähtaeg (päevad)</th>
          <th width="130">Saadetud</th>
          <th width="110" class="text-right">Summa</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="invoice in invoices" @click="showDetails(invoice)" style="cursor: pointer">
          <td>
            <span :class="{'badge badge-info' : invoice.typeLetter === 'K', 'badge badge-success' : invoice.typeLetter === 'E', }">
              {{ invoice.typeLetter }}</span>
          </td>
          <td>{{invoice.number}}</td>
          <td>{{invoice.clientName}}</td>
          <td>
            <span :class="'badge d-block badge-lg badge-'
            + invoiceStatusStyleClass(invoice.statusCode, invoice.typeLetter, (invoice.paymentDueDaysLeft < 0))">
              {{ invoice.status }}
            </span>
          </td>
          <td>{{invoice.createdByName}}</td>
          <td v-if="invoice.invoiceDate">{{invoice.invoiceDate | formatDate}}</td>
          <td v-else><small class="text-secondary">Loodud {{invoice.createdAt | formatDate}}</small></td>
          <td>
            <template v-if="invoice.dueDate">
              {{invoice.dueDate | formatDate}}
              <span class="badge badge-light">
                <span>
                  {{invoice.paymentDueDays}}
                </span>
                <span v-if="invoice.paymentDueDaysLeft">
                  <span class="text-muted">/</span>
                  <span :class="{'text-danger' : invoice.paymentDueDaysLeft < 0}">{{invoice.paymentDueDaysLeft}}</span>
                </span>
              </span>
            </template>
          </td>
          <td>
            <template v-if="invoice.lastEmail">
              <small>{{invoice.lastEmail.sentAt | formatDateTime}}</small>
            </template>
          </td>
          <td class="text-right">{{invoice.amount | amountWithCurrency}}</td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="invoices && !invoices.length" class="alert alert-light alert-card-attached">
      <i class="mdi mdi-information mr-1"></i>Arveid ei leitud
    </div>
    <div v-else class="alert alert-light alert-card-attached d-flex align-items-center">
      <div class="spinner-border spinner-border-sm mr-1"></div>
      <span>Laeme andmeid...</span>
    </div>
  </div>
</template>

<script>
import InvoiceStatusStyleClass from '../../mixins/InvoiceStatusStyleClass'
import QueryParamsMixin from '../../mixins/QueryParamsMixin'

export default {
  mixins: [InvoiceStatusStyleClass, QueryParamsMixin],
  props: ['filter'],
  data() {
    return {
      maxResults: 1000,
      invoices: null
    }
  },
  methods: {
    showDetails(invoice) {
      this.$router.push(`/invoices/${invoice.id}`)
    },
    loadInvoices() {
      this.invoices = null
      const params = {
        maxResults: this.maxResults,
        type: this.filter.type,
        status: this.filter.status,
        numberPrefix: this.filter.numberPrefix,
        clientId: this.filter.clientId,
          query: this.filter.query,
          from: this.filter.dateRange.from,
          until: this.filter.dateRange.until
        }
        return this.$gateway.get('/invoices', {params}).then(r => this.invoices = r.data)
      }
    },
    created() {
      this.loadInvoices()
    },
    computed: {
      exportParams() {
        return this.queryParams({
          status: this.filter.status,
          type: this.filter.type,
          numberPrefix: this.filter.numberPrefix,
          query: this.filter.query,
          clientId: this.filter.clientId,
          from: this.filter.dateRange.from,
          until: this.filter.dateRange.until
        })
      }
    },
    watch: {
      filter: {
        handler() {
          this.loadInvoices()
        },
        deep: true
      }
    }
  }
</script>
